<template>
    <div class="mPage">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'm_detailpage',
    data: function () {
        return {
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    position: relative;
    background-image: url(../img/m/m_bg.png);
    background-size: cover;
}

</style>
